import { createTheme, ThemeProvider, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import React from 'react';

interface ToolTipCircleProps {
  lgSize: '2xs' | 'xs' | 'sm' | 'base' | 'lg' | 'lg2' | 'xl' | '2xl' | '3xl';
  xlgSize: '2xs' | 'xs' | 'sm' | 'base' | 'lg' | 'lg2' | 'xl' | '2xl' | '3xl';
  text: string;
  placement?: 'bottom' | 'right' | 'left' | 'top' | any;
}

export const ToolTipCircle: React.FC<ToolTipCircleProps> = ({ lgSize, text, xlgSize, placement }) => (
  <Tooltip title={text} arrow className={`shadow-md text-${lgSize}`} placement={placement}>
    <InfoOutlined className="text-gray-500 hover:text-gray-700 cursor-help transition-colors" fontSize="small" />
  </Tooltip>
);

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: { padding: 0, backgroundColor: 'transparent' },
        arrow: { color: '#9c9c9c' },
      },
    },
  },
});

export const HtmlTooltip: React.FC<{ text: string; placement?: any }> = ({ text, placement }) => (
  <ThemeProvider theme={theme}>
    <Tooltip title={text} arrow className="shadow-md" placement={placement}>
      <InfoOutlined className="text-gray-500 hover:text-gray-700 cursor-help transition-colors" fontSize="small" />
    </Tooltip>
  </ThemeProvider>
);
